export default __webpack_public_path__ + "static/media/mail-icon.3754c088.svg";